import type { GLTFObject } from '@/lib/cad/GLTFObject'
import type { RawAssemblyTree } from '@/state'

import { useMemo } from 'react'
import { createSubAssemblyTree } from './lib/createSubAssemblyTree'
import { useOperationSteps } from '@/services/queries/operation_steps'
import { useCADPageStore } from '@/state/cad'
import { createStepOrderNumber } from '../AssemblyOrderPanel/lib/createStepOrderNumber'
import { TreeNodes } from './TreeNodes'
import { isEmptyOrSpaces } from '@/utils'

interface SubAssemblyTreeProps {
  tree?: RawAssemblyTree
  gltf: GLTFObject
}
export const SubAssemblyTree = ({ tree, gltf }: SubAssemblyTreeProps) => {
  const { steps } = useOperationSteps()

  const subAssemblyDocumentPageId = useCADPageStore(
    (state) => state.subAssemblyDocumentPageId,
  )
  const subTree = useMemo(
    () => createSubAssemblyTree({ tree, steps, subAssemblyDocumentPageId }),
    [tree, steps, subAssemblyDocumentPageId],
  )

  const subStep = useMemo(
    () => steps.find((s) => s.id === subAssemblyDocumentPageId),
    [steps, subAssemblyDocumentPageId],
  )

  const orderNumber = useMemo(
    () => createStepOrderNumber({ step: subStep, steps }),
    [subStep, steps],
  )

  if (!subTree || !subStep) {
    return null
  }

  return (
    <div className="border-b border-solid border-gray-400 pb-2 max-h-[50%]">
      <h2 className="text-center text-gray-400 italic text-xs pb-2 font-semibold sticky top-0 left-0 bg-white">
        {isEmptyOrSpaces(subStep.name)
          ? `Operation ${orderNumber}`
          : subStep.name}{' '}
        SubAssembly Tree
      </h2>

      {subTree && gltf && <TreeNodes tree={subTree} gltf={gltf} height="95%" />}
    </div>
  )
}
